<div *ngIf="data.action != 'delete' &&
  data.action !='creativeBulkUploadError' && data.action != 'libBulkUploadError' && data.action !='generateUrl'
  && data.action !='postalCodes' && data.action !='liBulkDuplicationError' && data.action != 'endedLi'" class="dailog-content">
  <div class="preview_dailog_action_header" style="margin-top: 0.5em" *ngIf="data.action != 'seed_help'">
    <span>
      <img class="alert-vizibl-logo" [src]="imgPath" />
      <h3 class="alertMessage">ALERT</h3>
      <div class="info-text">
        <span style="margin-right: 5px; margin-top:5px">{{
          data.action
          }}</span>
        <span *ngIf="!data.name && data.items>1">{{ data.items }} items  </span>
        <span *ngIf="!data.name && data.items==1">{{ data.items }} item  </span>
        <span *ngIf="data.action == 'Submit'">for Reaudit</span>
        <span *ngIf="data.items=='priority'" style="text-transform: capitalize">{{ data.name }} ? </span>
      </div>
    </span>

  </div>
  <mat-radio-group [(ngModel)]="priorityAudit" *ngIf="data.action == 'Submit'" aria-label="Select an option" [ngClass]="{'align-radios-center': true, 'mt-2': true}">
    <mat-radio-button class="ms-4 mt-2" [value]="false">Standard
      <span
      matTooltip="Auditing of your creative can take up to one business day"
      matTooltipClass="tooltip-class" matTooltipPosition="right" class="material-icons tool-tip">
      error
    </span>
    </mat-radio-button>
    <mat-radio-button class="ms-4" [value]="true" *ngIf="data.clientTier == 'professional'">High priority
      <span
      matTooltip="Complete the auditing of your creative within 2 hours at an additional cost of $25"
      matTooltipClass="tooltip-class" matTooltipPosition="right" class="material-icons tool-tip">
      error
    </span>
    </mat-radio-button>
  </mat-radio-group>

  <div class="preview_dailog_action_buttons mt-2 mb-1" *ngIf="data.action != 'seed_help'">
    <div *ngIf="!disablecancel" class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(false)">
        Cancel
      </button>
    </div>
    <div class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(true)">
        {{data.action.includes('Registration is pending')? 'Yes': 'OK'}}
      </button>
    </div>
  </div>
</div>

<div *ngIf="data.action == 'postalCodes'" class="dialog-content">
  <div class="preview_dailog_action_header">
    <span>
      <img class="alert-vizibl-logo" [src]="imgPath" />
      <h3 class="alertMessage">ALERT</h3>
        <div class="locations">
          <h4>There are multiple location with same postal codes. Choose the ones that you want to target:</h4>
          <mat-selection-list
            [(ngModel)]="selectedPostalCodes"
          >
            <mat-list-option
              *ngFor="let location of data.locations"
              [value]="location"
              checkboxPosition="before"
            >
              <span
                style="text-transform: capitalize">
                  {{ location.name }}
              </span>
            </mat-list-option>
          </mat-selection-list>
        </div>
    </span>
  </div>

  <div class="preview_dailog_action_buttons mt-2 mb-1" *ngIf="data.action != 'seed_help'">
    <div  class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(false)">
        Cancel
      </button>
    </div>
    <div class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(true)">
        OK
      </button>
    </div>
  </div>

</div>

<div *ngIf="data.action == 'delete'" class="dailog-content">
  <div class="preview_dailog_action_header">
    <span class="title"> Delete </span>
    <span class="delete_question">
      <span>Are you sure you want to delete </span>
      <span style="text-transform: capitalize">"{{ data.name }}" ? </span>
    </span>
  </div>

  <div  class="preview_dailog_action_buttons">
    <div class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(false)">
        Cancel
      </button>
    </div>
    <div class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(true)">
        Delete
      </button>
    </div>
  </div>
</div>

<div *ngIf="data.action == 'seed_help'" class="dailog-content">
  <div class="preview_dailog_action_header">
    <div style="text-align: center;">
      <h3 class="alertMessage">Seed Help</h3>
    </div>
  </div>


  <div class="seed_faq_content">
    <!-- Seed Info Section (static) -->
    <div class="warning_message seed_info" style="margin-left: 10%;">
      <p>Seeds tell our system about your ideal customers (purchasers/subscribers/site visitors etc):</p>
      <p>1) What sites do they visit?</p>
      <p>2) What keywords describe their interests?</p>
      <p>3) Which geo they are in?</p>
      <p>4) Are they similar to past site visitors or audience in third-party segments?</p>
    </div>

    <div class="faq_separator mt-2">
      <hr />
      <span class="faq_label mb-4">FAQs</span>
    </div>

    <!-- Seed FAQ Accordion -->
    <mat-accordion class="seed_faq_accordion" multi style="padding-top: 20px;">
      <mat-expansion-panel *ngFor="let faq of seedFaqs" style="margin-top: 5px;">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ faq.question }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p>{{ faq.answer }}</p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>


  <div class="preview_dailog_action_buttons">
    <div class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(false)">
        OK
      </button>
    </div>
  </div>
</div>

<div *ngIf="data.action == 'generateUrl'" class="dailog-content">
  <div class="preview_dailog_action_header" style="margin-top: 0.5em">
    <span>
      <img class="alert-vizibl-logo" [src]="imgPath" />
    </span>
    <span class="delete_question">
      <h3 class="alertMessage">Tag</h3>
      <span *ngIf="data.type=='website'"> {{tag_url}}</span>
      <span style="word-wrap: break-word;margin: 1%;" *ngIf="data.type=='ads'"> {{tag_url}}</span>
    </span>
  </div>
  <div class="preview_dailog_action_buttons">
    <div class="table_action_cell">
      <button cdkCopyToClipboard=tag_url mat-button class="action_btn_no-border" (click)="copyToClipboard(tag_url)">Copy text</button>
      <button mat-button class="action_btn_no-border" (click)="closeModelURL(false)">
       OK
      </button>
    </div>
  </div>
</div>

<!-- <div *ngIf="data.action == 'tdspGeoWarning'" class="dailog-content">
  <div class="preview_dailog_action_header" style="margin-top: 0.5em">
    <span>
      <img class="alert-vizibl-logo" [src]="imgPath" />
    </span>
    <span class="delete_question">
      <h3 class="alertMessage">Targeting</h3>
      <span> Choose either geography based targeting or custom location</span>
    </span>
  </div>
  <div class="preview_dailog_action_buttons">
    <div class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModelURL(false)">
       OK
      </button>
    </div>
  </div>
</div> -->

<div *ngIf="data.action == 'creativeBulkUploadError'" class="dailog-content">
  <div class="preview_dailog_action_header">
    <span>
      <img class="alert-vizibl-logo" [src]="imgPath" />
       <h3 class="alertMessage">ALERT</h3>
       <div class="info-text">
        <h4>Unable to upload the below
          <ng-container *ngIf="data.items.length==1">
            creative.
          </ng-container>
          <ng-container *ngIf="data.items.length>1">
            creatives.
          </ng-container>
          Please make the necessary corrections or remove them from the upload screen.
        </h4>
        <table class="creative-error-table">
          <thead>
            <th class="me-3"></th>
            <th class="me-3">Name</th>
            <th class="ms-3">Error</th>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of data.items; let i=index">
              <tr>
                <td>{{i+1}}</td>
                <td [title]="item.file_name.length <= 20 ? '' : item.file_name" style="cursor:pointer">
                  {{ item.file_name.length <=20 ? item.file_name: item.file_name.substring(0,20) + '...' }}
                </td>
                <td>{{ item.error }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </span>
  </div>
  <div class="preview_dailog_action_buttons">
    <div class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(true)">
        OK
      </button>
    </div>
  </div>
</div>

<div *ngIf="data.action == 'libBulkUploadError'" class="dailog-content">
  <div class="preview_dailog_action_header">
    <span>
      <img class="alert-vizibl-logo" [src]="imgPath" />
       <h3 class="alertMessage">ALERT</h3>
       <div class="info-text">
        <h4>Unable to upload the below
          <ng-container *ngIf="data.items.length==1">
            library item.
          </ng-container>
          <ng-container *ngIf="data.items.length>1">
            library items.
          </ng-container>
          Please make the necessary corrections or remove them from the upload screen.
        </h4>
        <table class="creative-error-table">
          <thead>
            <th class="me-3"></th>
            <th class="me-3">Name</th>
            <th class="ms-3">Error</th>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of data.items; let i=index">
              <tr>
                <td>{{i+1}}</td>
                <td [title]="item.name.length <= 20 ? '' : item.name" style="cursor:pointer">
                  {{ item.name.length <=20 ? item.name: item.name.substring(0,20) + '...' }}
                </td>
                <td>{{ item.error }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </span>
  </div>
  <div class="preview_dailog_action_buttons">
    <div class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(true)">
        OK
      </button>
    </div>
  </div>
</div>


<div *ngIf="data.action == 'liBulkDuplicationError'" class="dailog-content">
  <div class="preview_dailog_action_header">
    <span>
      <img class="alert-vizibl-logo" [src]="imgPath" />
       <h3 class="alertMessage">ALERT</h3>
       <div class="info-text">
        <h4>Duplication of the {{data.items.length==1 ? 'line item' : 'line items'}} failed.
          Please make the necessary corrections or remove them from the duplication screen.
        </h4>
        <table class="creative-error-table">
          <thead>
            <th class="me-3"></th>
            <th class="me-3">Name</th>
            <th class="ms-3">Error</th>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of data.items; let i=index">
              <tr>
                <td>{{i+1}}</td>
                <td [title]="item.name.length <= 20 ? '' : item.name" style="cursor:pointer">
                  {{ item.name.length <=20 ? item.name: item.name.substring(0,20) + '...' }}
                </td>
                <td>{{ item.error }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </span>
  </div>
  <div class="preview_dailog_action_buttons">
    <div class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(true)">
        OK
      </button>
    </div>
  </div>
</div>

<!--Expired LI Items-->

<div *ngIf="data.action == 'endedLi'" class="dailog-content">
  <div class="preview_dailog_action_header">
    <h3 class="alertMessage">ALERT</h3>
    <span class="delete_question">
      <span>The following Line Items ended and cannot be updated: [<strong>{{data.endedLiItems}}</strong>] </span>
      <span>Bulk Edit will be applied to active Line Items.</span>
      <span>Do you want to continue?</span>
    </span>
  </div>

  <div  class="preview_dailog_action_buttons">
    <div class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(false)">
        Cancel
      </button>
    </div>
    <div class="table_action_cell">
      <button mat-button class="action_btn_no-border" (click)="closeModel(true)">
        Continue
      </button>
    </div>
  </div>
</div>
